import { styled, Checkbox } from '@mui/material';

export const DefaultCheckbox = styled(Checkbox)(({ theme }) => ({
  '&': {
    color: theme.palette.neutralLight.dark,
    padding: 0,
    marginRight: 12,
  },
}));
